import React, { useEffect, useState, SyntheticEvent } from 'react'
import Link from 'next/link'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import SeriesDetailLink from 'Components/links/series-detail'
import { ArticleData } from 'Pages/home/featured-videos'
import classnames from 'classnames'
import get from 'lodash/get'
import Swiper from 'react-id-swiper'
import 'lib/swiper.less'
import applyHttpsImage from 'lib/apply-https-img'
import getUrl from 'lib/url'
import ArticleLeaderboard from 'Pages/home/article-leaderboard'
import FriendShipLink, { IFriendshipLinkData } from 'Pages/home/friendship-link'
import ArticleLink from 'Components/links/article-link'
import Statement from 'Components/statement'
import NoSSR from 'react-no-ssr'
import Loading from 'Components/loading'
import Feed, { TabData } from 'Pages/home/feed'
import RightButtonAD2 from './ad/right-button02'
import RightButtonAD1 from './ad/right-button01'
import { IRightButtonADInterface } from './ad/interface'
interface IProps {
  bannerList: any
  pcHotVideoList: ArticleData[]
  articleList: ArticleData[]
  friendshipLinkData: IFriendshipLinkData[]
  feedTabData: TabData[]
}

interface AdData {
  video_rank_top_ad: IRightButtonADInterface
  article_rank_top_ad: IRightButtonADInterface
}

export interface SeriesData {
  series_id: number
  series_name: string
  cover_url: string
}
export default function FeedHome({
  bannerList,
  pcHotVideoList,
  articleList,
  friendshipLinkData,
  feedTabData,
}: IProps) {
  const onBannerClick = (group_id: string) => {
    sendTeaCommEvent('click_news_top_banner', {
      group_id,
    })
  }
  const [adData, setAdData] = useState<AdData>()
  useEffect(() => {
    fetch(getUrl('/motor/ad/m/pc/page_information'))
      .then(res => res.json())
      .then(res => {
        setAdData(res.data)
      })
  }, [])

  return (
    <div className="feed-home">
      <section className="card-wrapper" id="featured_images">
        <div className="car-atlas">
          <div className="left-section">
            <Link href={get(bannerList[0], 'share_url', '')}>
              <a target="_blank">
                <div
                  className="image-transition"
                  onClick={() => {
                    onBannerClick(bannerList?.[0]?.group_id || 'undefined')
                  }}
                >
                  <div
                    className="big-image"
                    style={{
                      backgroundImage: `url(${applyHttpsImage(
                        get(bannerList[0], 'url', '')
                      )})`,
                    }}
                    onClick={() => {
                      onBannerClick(bannerList[0]?.group_id)
                    }}
                  />
                  <span className="title-cover" />
                  <div className="article-title">
                    {get(bannerList[0], 'title') || ''}
                  </div>
                </div>
              </a>
            </Link>
          </div>
          <div className="middle-section">
            {bannerList
              .slice(1, 5)
              .map((item: { group_id: string }, index: number) => (
                <div
                  className="image-wrapper"
                  key={get(item, 'group_id', '') + index}
                >
                  <Link href={get(item, 'share_url', '')}>
                    <a target="_blank">
                      <div
                        className="image-transition"
                        onClick={() => {
                          onBannerClick(item?.group_id || 'undefined')
                        }}
                      >
                        <div
                          className="small-image"
                          style={{
                            backgroundImage: `url(${applyHttpsImage(
                              get(item, 'url', '')
                            )})`,
                          }}
                        />
                        <span className="title-cover" />
                        <div className="article-title">
                          {get(item, 'title', '')}
                        </div>
                      </div>
                    </a>
                  </Link>
                </div>
              ))}
          </div>
          <div className="right-section">
            {adData && adData.video_rank_top_ad ? (
              <RightButtonAD1 data={adData.video_rank_top_ad} />
            ) : (
              <Link href={get(bannerList[5], 'share_url', '')}>
                <a target="_blank">
                  <div
                    className="image-transition"
                    onClick={() => {
                      onBannerClick(bannerList?.[5]?.group_id || 'undefined')
                    }}
                  >
                    <div
                      className="big-image"
                      style={{
                        backgroundImage: `url(${applyHttpsImage(
                          get(bannerList[5], 'url', '')
                        )})`,
                      }}
                      onClick={() => {
                        onBannerClick(bannerList[5]?.group_id)
                      }}
                    />
                    <span className="title-cover" />
                    <div className="article-title">
                      {get(bannerList[5], 'title') || ''}
                    </div>
                  </div>
                </a>
              </Link>
            )}
          </div>
        </div>
      </section>
      <div className="flex-box">
        <div className="feeds">
          <NoSSR onSSR={<Loading />}>
            <Feed fromPage="feed" tabData={feedTabData} />
          </NoSSR>
        </div>
        <div className="leaderboards">
          {pcHotVideoList?.length > 0 && (
            <section className="video-leaderboard">
              <div className="videos-wrapper">
                <div className="title">
                  <span>视频排行榜</span>
                </div>
              </div>
              <ul style={{ marginTop: '1px' }}>
                {Array.isArray(pcHotVideoList) &&
                  pcHotVideoList.slice(0, 10).map((item, index) => {
                    return (
                      <li key={item.gid_str} className="line-1">
                        <ArticleLink
                          gid={item.gid_str}
                          onClick={() => {
                            sendTeaCommEvent('click_news_top_video', {
                              group_id: item?.gid_str || 'undefined',
                            })
                          }}
                          className="line-1"
                        >
                          <span
                            className={classnames(`gid-index gid-${index}`)}
                          >
                            {index + 1}
                            {index < 3 ? null : '.'}
                          </span>
                          <span
                            className={classnames('gid-title', {
                              'gid-title-bold': index < 3,
                            })}
                          >
                            {item.title}
                          </span>
                        </ArticleLink>
                        <span className="gid-count">{item.count}万次播放</span>
                      </li>
                    )
                  })}
              </ul>
            </section>
          )}
          {/* PC-资讯页-右侧按钮02 */}
          {adData && adData.article_rank_top_ad ? (
            <RightButtonAD2 data={adData.article_rank_top_ad} />
          ) : (
            ''
          )}
          {articleList?.length > 0 && (
            <section className="article-leaderboard">
              <ArticleLeaderboard article={articleList} fromPage="feed" />
            </section>
          )}

          {friendshipLinkData?.length > 0 && (
            <section className="friendship-link-data">
              <FriendShipLink friendshipLinkData={friendshipLinkData} />
            </section>
          )}

          <section className="statement">
            <Statement />
          </section>
        </div>
      </div>

      <style jsx>
        {`
          .feed-home {
            width: 1196px;
            margin: 0 auto 0;
          }
          .card-wrapper {
            padding-top: 16px;
            display: flex;
          }
          .car-atlas {
            height: 268px;
            display: flex;
            justify-content: space-between;
            width: 100%;
          }

          .left-section {
            width: 380px;
            border-radius: 2px;
          }
          .middle-section {
            width: 404px;
            display: flex;
            flex-wrap: wrap;
          }
          .image-transition {
            overflow: hidden;
            position: relative;
            cursor: pointer;
            border-radius: 2px;
          }
          .image-transition:hover .small-image::before,
          .image-transition:hover .big-image::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 1;
            background-color: rgba(0, 0, 0, 0.4);
          }
          .image-transition:hover .big-image,
          .image-transition:hover .small-image {
            transform: scale(1.1);
          }
          .big-image,
          .small-image {
            position: relative;
            background-size: cover;
            transition: transform 0.3s ease-in-out;
            border-radius: 2px;
          }
          .big-image {
            width: 380px;
            height: 268px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
          }
          .small-image {
            width: 194px;
            height: 130px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
          }
          .middle-section .image-wrapper {
            margin-bottom: 8px;
          }
          .middle-section .image-wrapper:nth-child(2n) {
            margin-left: 16px;
          }

          .article-title {
            position: absolute;
            line-height: 20px;
            left: 0;
            right: 0;
            width: 100%;
            text-align: start;
            color: #ffffff;
            padding: 0 9px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            z-index: 2;
            color: white;
            font-size: 16px;
            font-weight: 500;
            min-width: 0;
          }

          .title-cover {
            content: '';
            position: absolute;
            bottom: 0;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0),
              #000000
            );
            width: 100%;
            left: 0;
          }

          .image-transition:hover .article-title {
            color: #ffcd32;
            position: absolute;
            overflow: hidden;
            background-image: none;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-break: break-all;
            white-space: normal;
            -webkit-line-clamp: 3;
          }

          .image-transition:hover .article-title span {
            z-index: 2;
            position: relative;
          }

          .left-section .article-title,
          .right-section .article-title {
            line-height: 20px;
            font-size: 16px;
            font-weight: 500;
            bottom: 12px;
            padding: 0 12px;
          }
          .left-section .article-title::after,
          .right-section .title-cover {
            height: 46px;
            bottom: -12px;
          }
          .middle-section .article-title {
            line-height: 20px;
            font-weight: 14px;
            bottom: 6px;
            padding: 0 8px;
          }
          .middle-section .title-cover {
            height: 32px;
            bottom: -6px;
          }

          .big-image::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 40px;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0),
              #1f2129
            );
          }
          .video-leaderboard {
            width: 380px;
            margin-left: 10px;
            margin-top: 40px;
          }
          .article-leaderboard {
            width: 380px;
            margin-left: 10px;
            margin-top: 31px;
          }
          .fr {
            float: right;
          }
          .car-gid-wrapper {
            width: 380px;
            margin-left: 16px;
          }
          .car-gid {
            width: 380px;
            height: 268px;
            border-radius: 2px;
          }
          .videos-wrapper {
            margin-bottom: 16px;
          }
          .title span {
            line-height: 36px;
            font-size: 24px;
            font-weight: 500;
          }
          .line-1 {
            margin-bottom: 17px;
            display: flex;
            width: 100%;
          }
          .line-1:last-child {
            margin-bottom: 0;
          }
          .gid-index {
            display: inline-block;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 18px;
            letter-spacing: normal;
            color: #979aa8;
            width: 18px;
            height: 18px;
            border-radius: 2px;
            text-align: center;
            margin-right: 8px;
          }
          .gid-0 {
            background-color: #e62021;
            color: #ffffff;
          }
          .gid-1 {
            background-color: #e65800;
            color: #ffffff;
          }
          .gid-2 {
            background-color: #f5b330;
            color: #ffffff;
          }
          .gid-title {
            font-size: 14px;
          }
          .gid-title-bold {
            font-weight: 500;
          }
          .gid-count {
            margin-left: auto;
            font-size: 12px;
            color: #979aa8;
            padding-left: 12px;
          }

          .flex-box {
            display: flex;
            justify-content: space-between;
          }

          .feeds {
            margin-top: 40px;
            min-width: 800px;
          }

          .leaderboards {
            margin-left: 16px;
          }
        `}
      </style>
    </div>
  )
}

FeedHome.getInitialProps = async ({ req }: any) => {
  const bannerData = async () => {
    const json = await fetch(getUrl('/motor/pleasure/pc/news_daily'))
      .then(res => res.json())
      .catch(err => {
        console.error('[fetch] banner data error', err)
        return []
      })
    let data = json?.data || []
    if (!Array.isArray(data)) {
      data = []
    }
    return data
  }

  const pcHotVideo = async () => {
    const json = await fetch(
      getUrl(`/motor/m_api/pc_hot_rank?source_from=video`)
    )
      .then(res => res.json())
      .catch(err => {
        console.error('[fethc] pcHotVideo error', err)
        return []
      })

    let data = json?.data || []
    if (!Array.isArray(data)) {
      data = []
    }
    return data
  }

  const pcHotArticle = async () => {
    const json = await fetch(
      getUrl(`/motor/m_api/pc_hot_rank?source_from=article`)
    )
      .then(res => res.json())
      .catch(err => {
        console.error('[fethc] pcHotArticle error', err)
        return []
      })

    let data = json?.data || []
    if (!Array.isArray(data)) {
      data = []
    }
    return data
  }

  /* 获取友情链接数据 */
  const friendshipLinkData = async () => {
    try {
      const res = await fetch(
        getUrl('/cloud/api/invoke/get_pc_friendship_link')
      )
      const json = await res.json()
      return json || []
    } catch (err) {
      console.error(err)
      return []
    }
  }

  const feedTabData = async () => {
    try {
      const res = await fetch(getUrl('/motor/m_api/pc_information_tab'))
      const json = await res.json()
      let data = json?.data || []
      if (!Array.isArray(data)) {
        data = []
      }
      return data
    } catch (err) {
      console.error(err)
      return []
    }
  }

  const data = await Promise.all([
    bannerData(),
    pcHotVideo(),
    pcHotArticle(),
    friendshipLinkData(),
    feedTabData(),
  ])

  return {
    bannerList: data[0]
      .slice(0, 6)
      .map((ele: { info: any; unique_id_str: string }) => {
        const e = ele.info
        return {
          group_id: ele.unique_id_str,
          url: e.image_list?.[0]?.url,
          share_url: e.share_info.share_url,
          title: e.title,
        }
      }),

    pcHotVideoList: data[1],
    articleList: data[2],
    friendshipLinkData: data[3],
    feedTabData: data[4],
  }
}
